import Splide from '@splidejs/splide';

export const timeline = () => {
  const timelineItems = document.querySelectorAll('.wp-block-timeline .timeline-item');

  if (!timelineItems.length) return;

  let margin = window.innerHeight * 0.7;

  //  when timeline item is at 40% from top of screen, add class is-active
  const onIntersect = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-active');
      } else {
        entry.target.classList.remove('is-active');
      }
    });
  };

  let observer = new IntersectionObserver(onIntersect, {
    rootMargin: `0px 0px -${margin}px 0px`,
  });

  timelineItems.forEach((timelineItem) => observer.observe(timelineItem));

  // on window resize update margin
  const onResize = () => {
    let newMargin = window.innerHeight * 0.666;

    if (margin !== newMargin) {
      observer.disconnect();
      margin = newMargin;

      observer = new IntersectionObserver(onIntersect, {
        rootMargin: `0px 0px -${margin}px 0px`,
      });

      timelineItems.forEach((timelineItem) => observer.observe(timelineItem));
    }
  };

  window.addEventListener('resize', onResize);

  // mobile
  const contents = new Splide('.splide.content', {
    focus: 'start',
    gap: 16,
    arrows: false,
    pagination: false,
  });

  const years = new Splide('.splide.year', {
    isNavigation: true,
    focus: 'start',
    gap: 32,
    rewind: true,
    arrows: false,
    pagination: false,
    fixedWidth: true,
    dragMinThreshold: {
      mouse: 4,
      touch: 10,
    },
  });

  contents.sync(years);
  contents.mount();
  years.mount();
};
